export const MuiTablePagination = {
  MuiTablePagination: {
    styleOverrides: {
      selectLabel: {
        color: "rgba(0, 0, 0, 0.6)",
      },
    },
  },
};
